const reportFormSet = () => {
    const reportButs = document.querySelectorAll('button[data-dwn]');

    reportButs.forEach(but => {
        but.addEventListener('click', () =>{
            const butData = but.dataset.dwn;
            const inputHiden = document.querySelector('.form-diz__hidden input');
            inputHiden.value = butData;
            document.querySelector( '.form-report .popup__thx' ).classList.remove('active');
        }, false)
    });
}

module.exports = reportFormSet;